export async function fetchCaeFormatterTranslations(params) {
    const locale = `${params.language}-${params.country.toUpperCase()}`;
    const response = await fetch(`${params.baseUrl}/${locale}.json`);
    if (!response.ok) {
        return null;
    }
    const data = await response.json();
    return data;
}
//# sourceMappingURL=i18n.js.map